import {GeneratorRequest} from "./GeneratorRequest";

const nomApi = "roles"

export const RoleRepository = {
    gets : GeneratorRequest.gets(nomApi, true),
    delete: GeneratorRequest.delete(nomApi, true),
    put: GeneratorRequest.put(nomApi, true)
}
